<template>
    <main-section class="main-section--sm">
        <square-title>인증마크</square-title>

        <div class="tit-wrap">
            <marks-list />
        </div>

        <v-row no-gutters justify="center">
            <v-col cols="auto">
                <v-btn x-large color="primary" @click="tempMsg">OEM/ODM 문의하기</v-btn>
            </v-col>
        </v-row>
    </main-section>
</template>

<script>
import MainSection from "@/components/client/inc/main-section.vue";
import SquareTitle from "../dumb/square-title.vue";
import MarksList from "../dumb/marks-list.vue";

export default {
    components: {
        MainSection,
        SquareTitle,
        MarksList,
    },
    methods: {
        tempMsg() {
            alert("준비 중입니다.");
        },
    },
};
</script>